import React, { Component } from "react";
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import MenuClose from './MenuClose';
import Menu from './Menu';

class MenuContainer extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      visible: false
    };

    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
  }

  handleMouseDown(e) {
    this.toggleMenu();

    console.log("clicked");
    e.stopPropagation();
  }

  toggleMenu() {
    this.setState(
      {
        visible: !this.state.visible
      }
    );
  }

  render() {


   return (

         <div>
             <MenuClose handleMouseDown={this.handleMouseDown}/>
             <Menu handleMouseDown={this.handleMouseDown}
                   menuVisibility={this.state.visible}/>
         </div>

   );
 }
}



export default MenuContainer;



// WEBPACK FOOTER //
// ./src/components/MenuContainer.jsx